module.exports = __webpack_public_path__ + "img/qvest_page_preview_bg.png";